// Core JS
import '../javascript/jquery_browser.js'

// JS dependencies
import 'bootstrap';

import '@fortawesome/fontawesome-free/scss/fontawesome.scss';
import '@fortawesome/fontawesome-free/scss/regular.scss';
import '@fortawesome/fontawesome-free/scss/solid.scss';

require('webpack-jquery-ui/datepicker');
require('webpack-jquery-ui/css');

import LocalTime from 'local-time';
LocalTime.start()

// Local JS
import '../javascript/application/';

// Stylesheets
import '../stylesheets/application/';

// Import all images served by Webpack
require.context('../images', true)

// Unobtrusive JavaScript
require("jquery-ujs")
